module.exports = __webpack_public_path__ + "static/media/conversationSkills2ffc9dc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/conversationSkills.svg
// module id = 1323
// module chunks = 0